import { Globe } from 'lucide-react';
import { Outlet } from 'react-router-dom';

import { AuthCarousel } from '@/components/AuthCarousel';
import { LanguageSelector } from '@/components/LanguageSelector';
import { TenantLogo } from '@/components/TenantLogo';

export function AuthLayout() {
  return (
    <main className="flex h-dvh p-[40px] lg:p-5">
      <section className="relative w-full lg:w-1/2">
        <div className="absolute right-4 top-1 flex w-full justify-end">
          <div className="flex w-full max-w-[240px] items-center gap-2">
            <Globe className="h-4 w-4 text-gray-600" />
            <LanguageSelector />
          </div>
        </div>

        <div className="absolute left-1/2 top-32 -translate-x-1/2">
          <TenantLogo />
        </div>

        <div className="flex h-full w-full flex-col items-center justify-center">
          <Outlet />
        </div>
      </section>

      <section className="relative hidden w-1/2 lg:block">
        <AuthCarousel />
      </section>
    </main>
  );
}
